import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Notification",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Iconly/Light/Notification",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Notification_2",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Stroke-1",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z",
					stroke: "#747474",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Stroke-3",
					d: "M14.3889 20.8572C13.0247 22.3719 10.8967 22.3899 9.51953 20.8572",
					stroke: "#747474",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			})
		})
	})
});
export { SvgNotification as ReactComponent };
